<template>
  <div class="questionnaireLinks">
    <!-- 添加表格 -->
      <el-card>
        <el-button type="primary" slot="header" @click="addLink()">{{$t('lang.btn_addQuesLink')}}</el-button>
        <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
          <!-- checkbox -->
          <el-table-column type="selection" width="55" v-if="questionnaireLinksListcheckbox"></el-table-column>
          <!-- 序号 -->
          <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
          <!-- 链接 -->
          <el-table-column prop="targetUri" :label="$t('lang.lab_link')">
            <template slot-scope="scope">
              <el-tooltip placement="top"
                effect="light"
                v-if="scope.row.targetUri&&scope.row.targetUri.length> require('@/config/enum').tableDatamaxlength30"
                :disabled="false">
                <div slot="content">
                  <span >{{ scope.row.targetUri }}</span>
                </div>
                <div>
                  {{ scope.row.targetUri.substring(0, require('@/config/enum').tableDatamaxlength30) | valueIsNull }}
                  <span v-if="scope.row.targetUri.length>require('@/config/enum').tableDatamaxlength30">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.targetUri | valueIsNull }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column prop="state" :label="$t('lang.lab_stateLink')">
            <template slot-scope="scope">
              <span v-if="scope.row.state === 1">{{$t('lang.QUESTIONNAIRELINKS.TYPE[0].label')}}</span>
              <span v-if="scope.row.state === 2">{{$t('lang.QUESTIONNAIRELINKS.TYPE[1].label')}}</span>             
            </template>
          </el-table-column>
          <!-- 过期时间 -->
          <el-table-column prop="endTime" sortable :label="$t('lang.lab_deadline')">
            <template slot-scope="scope">{{ scope.row.endTime | timeYMD }}</template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="changeLink(scope.row.id)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deleteLink(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>         
        </el-table>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
      </el-card>
      <!-- 添加弹框 -->
      <el-dialog
        :title="titleShow"
        :visible.sync="diaIsShow"
        :close-on-click-modal="false"
        center
        top="130px"
        width="600px"
        @closed="handleDialogClosed">
        <!-- 表单验证 -->
        <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
          <!-- 选择小区 -->
          <el-form-item :label="$t('lang.lab_quesCommunity')" prop="villages" v-if="this.editId === ''">
            <el-select 
              class="select"
              v-model="form.villages" 
              :placeholder="$t('lang.lab_selectCommunity')"
              multiple
              filterable
              @change="change"
              >
              <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
              <el-option v-for="item in villagetypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <!-- 添加链接 -->
          <el-form-item :label="$t('lang.lab_link')" prop="input">
            <el-input v-model="form.input" :placeholder="$t('lang.lab_pleInputLink')"></el-input>
          </el-form-item>
          <!-- 添加状态 -->
          <el-form-item  :label="$t('lang.lab_stateLink')">
            <el-select  v-model="form.state">
              <el-option
              v-for="(item,index) in states"
              :key="index"
              :label="item.label"
              :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 过期时间 -->
          <el-form-item :label="$t('lang.lab_deadTime')" >
            <el-date-picker 
              class="outDate" 
              v-model="form.endDate" 
              type="date" 
              :placeholder="$t('lang.lab_selectDeadlineTime')" 
              value-format="timestamp"
              :picker-options="pickerOptions0">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
          <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
        </div>
      </el-dialog>
   </div>
</template>

<script>
/**
 *@ClassName:questionnaireLinks
 *@Description:问卷调查链接
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-13
 */
import { mapGetters } from 'vuex'

export default {
  // 默认显示数据
  data() {
    // eslint-disable-next-line
    var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
    }
    return {
      isDisabled: true, // 按钮置灰
      saveData: '', // 存储json字符串
      editId: '', // 接收参数
      villagetypes: [], // 小区
      states: this.$i18n.t('lang.QUESTIONNAIRELINKS.TYPE'), // 状态
      titleShow: '', // 弹框标题
      diaIsShow: false, // 弹框是否显示
      tableData: [],
      multipleSelection: [], // 多选框
      oldsearchUnit: [], // 复选输入框change前的数据
      questionnaireLinksListcheckbox: require('@/config/enum').questionnaireLinksListcheckbox, // 是否隐藏复选框
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      form: {
        villages: '',
        input: '',
        state: 1,
        endDate: '',
      },
      rules: {
        input: [{ required: true, validator: validatePass, trigger: 'blur' }],
        villages: [{ required: true, message: this.$i18n.t('lang.lab_chooseGarden'), trigger: 'change' }],
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
    }
  },
  // 初始化
  created() {
    this.gardens()
    this.topics()
  },
  computed: {
    ...mapGetters(['gardenId'])
  },
  // 监听小区编号变化
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics()
    },
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 多选项
    change(val) {      
      const allValues = []
      // 将全选"0"加入allValues
      allValues.push(0)
      for (const item of this.villagetypes) {
        allValues.push(item.id)
      }
      // 用来储存上一次选择的值，可进行对比
      const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
      // 若选择全部
      if (val.includes(0)) {
        this.form.villages = allValues
      }
      // 取消全部选中， 上次有， 当前没有， 表示取消全选
      if (oldVal.includes(0) && !val.includes(0)) {
        this.form.villages = []
      }
      // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
      if (oldVal.includes(0) && val.includes(0)) {
        const index = val.indexOf(0)
        val.splice(index, 1)
        this.form.villages = val
      }
      // 全选未选，但是其他选项都全部选上了，则全选选上
      if (!oldVal.includes(0) && !val.includes(0)) {
        if (val.length === allValues.length - 1) {
          this.form.villages = [0].concat(val)
        }
      }
      // 储存当前选择的最后结果 作为下次的老数据
      this.oldsearchUnit[0] = this.form.villages
    },
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.villagetypes = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 显示页面
    topics() {
      let loading = this.$loading()
      this.$get(`/questionnaire/?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    addLink() {
      this.editId = ''
      this.titleShow = this.$i18n.t('lang.btn_addQuesLink')
      this.form.villages = []
      this.form.input = ''
      this.form.state = 1
      this.form.endDate = ''
      this.diaIsShow = true
    },
    changeLink(id) {
      this.editId = id
      this.titleShow = this.$i18n.t('lang.btn_changeQuesLink')
      let loading = this.$loading()
      this.$get(`/questionnaire/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.villages = []
            this.form.input = res.targetUri
            this.form.state = res.state
            this.form.endDate = res.endTs
            this.saveData = JSON.stringify(this.form)           
            this.diaIsShow = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
      
      this.diaIsShow = true
    },
    deleteLink(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`questionnaire/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.topics()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }).catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 弹窗保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.editId === '') {
           if (this.form.villages.includes(0)) {
              this.form.villages.splice(0, 1)
            }
            let params = {
              'state': this.form.state,
              'targetUri': this.form.input,
              'endTs': this.form.endDate,
              'garden[]': this.form.villages.toString()
            }
            let loading = this.$loading()
            this.$post(`/questionnaire`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let loading = this.$loading()
            let params = {
              state: this.form.state,
              targetUri: this.form.input,
              endTs: this.form.endDate
            }
            this.$patch(`/questionnaire/${this.editId}`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.diaIsShow = false
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.diaIsShow = false
                this.$message.error(error)
              }
            )
          }
        }
      })
    },
    // 弹窗清空
    clear() {
      this.form.villages = []
      this.form.input = ''
      this.form.state = ''
      this.form.endDate = ''
      this.$refs.form.clearValidate()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.clear()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang= 'scss'>
  .el-tooltip__popper.is-light {
    max-width: 300px;
  } 
</style>
